import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IntlPhoneNumComponent} from './intl-phone-num/intl-phone-num.component';
import {PatientConsultationsComponent} from './patient-consultations/patient-consultations.component';
import {
  PatientConsultationFormComponent
} from './patient-consultations/patient-consultation-form/patient-consultation-form.component';
import {ConsultationPopupComponent} from './consultation-popup/consultation-popup.component';
import {CurrentConsultationComponent} from './consultation-popup/current-consultation/current-consultation.component';
import {NextConsultationComponent} from './consultation-popup/next-consultation/next-consultation.component';
import {ConsultationDetailsComponent} from './consultation-popup/consultation-details/consultation-details.component';
import {
  ExternalDragAndDropComponent
} from '@clinician/shared/components/external-drag-and-drop/external-drag-and-drop.component';
import {AccordionTabComponent} from './accordion/accordion-tab/accordion-tab.component';
import {AccordionComponent} from './accordion/accordion.component';
import {DateValueListItemComponent} from './date-value-list-item/date-value-list-item.component';
import {LayoutComponentsModule} from '@shared/modules/layout-components/layout-components.module';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {DndModule} from 'ngx-drag-drop';
import {PatientDetailMediumComponent} from './patient-detail-medium/patient-detail-medium.component';
import {EntityDetailComponentsModule} from '@shared/modules/entity-details/entity-detail-components.module';
import {
  ConsultStartStopBtnComponent
} from './consultation-popup/consult-start-stop-btn/consult-start-stop-btn.component';
import {
  ConsultationPopupItemComponent
} from './consultation-popup/consultation-popup-item/consultation-popup-item.component';

@NgModule({
    exports: [
        IntlPhoneNumComponent,
        PatientConsultationsComponent,
        ExternalDragAndDropComponent,
        AccordionComponent,
        AccordionTabComponent,
        DateValueListItemComponent,
        PatientConsultationFormComponent,
        ConsultationPopupComponent,
        PatientDetailMediumComponent,
    ],
    imports: [
        DndModule,
        CommonModule,
        SharedModule.forChild(),
        RouterModule,
        ReactiveFormsModule,
        LayoutComponentsModule,
        FormsModule,
        EntityDetailComponentsModule,
        BsDropdownModule.forRoot(),
        IntlPhoneNumComponent,
        PatientConsultationsComponent,
        PatientConsultationFormComponent,
        ConsultationPopupComponent,
        CurrentConsultationComponent,
        NextConsultationComponent,
        ConsultationDetailsComponent,
        ExternalDragAndDropComponent,
        AccordionComponent,
        AccordionTabComponent,
        DateValueListItemComponent,
        PatientDetailMediumComponent,
        ConsultStartStopBtnComponent,
        ConsultationPopupItemComponent
    ],
    providers: []
})
export class ClinicianDashboardComponentsModule {
}
